module.exports = __webpack_public_path__ + "static/media/activetransactrionicon.0810c39d.svg";